import React from "react";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Box, Typography } from "@mui/material";
// import { ReactComponent as Help } from "@deere/ux.brand-foundations/icons/help.svg";

export default function RenderDirection(props) {
  const { value } = props;

  let icon;
  switch (value) {
    case "INBOUND":
      icon = <ArrowDownwardIcon />;
      break;
    case "OUTBOUND":
      icon = <ArrowUpwardIcon />;
      break;
    default:
      icon = <fuel-icon name={"help"} />;
  }
  return (
    <Box alignItems={"center"} display={"flex"} flexDirection={"row"}>
      {icon}
      <Typography pl={".25rem"} size="sm" component="p">
        {value}
      </Typography>
    </Box>
  );
}
